import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { NoticesService } from '../services/notices/notices.service';

@Injectable({
  providedIn: 'root',
})
export class NoticeResolverService implements Resolve<any[]> {
  constructor(private noticeService: NoticesService, private router: Router) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): any[] | Observable<any[]> | Promise<any[]> {
    const notice = this.noticeService.getNotices();
    if (notice.length === 0) {
      this.splitUrl();
    } else {
      return notice;
    }
  }
  splitUrl() {
    let url = location.pathname.split('/');
    if (url.length === 3) {
      this.noticeService.getNoticeSearchList(url[2]);
    }
  }
}
